"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpPerformQuestionNumber = void 0;
const safeParseFloat_1 = require("@opsbase/lib-general/utils/safeParseFloat");
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const Flag_1 = require("@opsbase/lib-issue/Flag");
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerformActions"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const usePerformQuestionActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestionActions"));
const useForceUpdate_1 = __importDefault(require("@opsbase/react-hooks/useForceUpdate"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = require("@opsbase/web-layout/Vertical");
const TextField_1 = __importDefault(require("@opsbase/web-textfield/TextField"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const consts_1 = require("../../consts");
const OpPerformQuestionCard_1 = __importDefault(require("../../OpPerformQuestionCard"));
const makeMyClasses = color => ({
    textField: {
        '& input': {
            color: color ? `${color === null || color === void 0 ? void 0 : color.main} !important` : undefined,
            padding: '12px 16px !important',
            width: 100,
        },
        '& fieldset': {
            borderColor: color ? `${color === null || color === void 0 ? void 0 : color.main} !important` : undefined,
            borderRightWidth: color ? 16 : undefined,
        },
    },
});
function OpPerformQuestionNumber(props) {
    const { rule, answer } = (0, usePerformQuestion_1.default)();
    const { doChangeAnswer } = (0, usePerformQuestionActions_1.default)();
    const { doSetHasError } = (0, usePerformActions_1.default)();
    const { forceUpdate } = (0, useForceUpdate_1.default)();
    const value = (0, safeParseFloat_1.safeParseFloat)(answer === null || answer === void 0 ? void 0 : answer.value);
    const [error, setError] = (0, react_1.useState)('');
    const color = (0, react_1.useMemo)(() => {
        var _a;
        const lt = rule.lessThan;
        const mt = rule.moreThan;
        const answered = ((_a = answer === null || answer === void 0 ? void 0 : answer.value) === null || _a === void 0 ? void 0 : _a.toString()) === '0' || !!(answer === null || answer === void 0 ? void 0 : answer.value);
        const isLessThan = lt && (lt === null || lt === void 0 ? void 0 : lt.value) !== '' && value < (0, safeParseFloat_1.safeParseFloat)(lt === null || lt === void 0 ? void 0 : lt.value);
        const isMoreThan = mt && mt.value !== '' && value > (0, safeParseFloat_1.safeParseFloat)(mt === null || mt === void 0 ? void 0 : mt.value);
        if (!answered)
            return undefined;
        if (isLessThan)
            return (0, Flag_1.flagColor)(lt === null || lt === void 0 ? void 0 : lt.flag);
        if (isMoreThan)
            return (0, Flag_1.flagColor)(mt === null || mt === void 0 ? void 0 : mt.flag);
        return undefined;
    }, [answer === null || answer === void 0 ? void 0 : answer.value, rule.lessThan, rule.moreThan, value]);
    const { mode } = (0, usePerform_1.default)();
    const viewMode = mode === 'view';
    const myCss = (0, web_css_1.default)(makeMyClasses, [color]);
    const handleChange = (0, react_1.useCallback)(newV => {
        var _a, _b;
        let precisionValue = 0;
        if (Math.floor(newV) === newV) {
            precisionValue = 0;
        }
        else {
            precisionValue = ((_b = (_a = newV === null || newV === void 0 ? void 0 : newV.toString()) === null || _a === void 0 ? void 0 : _a.split('.')[1]) === null || _b === void 0 ? void 0 : _b.length) || 0;
        }
        const hasDefaultMinMaxValue = rule.maxValue === 10 && rule.minValue === 0;
        const hasNoMaxValue = (!rule.maxValue && rule.maxValue !== 0) || hasDefaultMinMaxValue;
        const hasNoMinValue = (!rule.minValue && rule.minValue !== 0) || hasDefaultMinMaxValue;
        if (!isNaN(parseFloat(newV)) &&
            ((!hasNoMaxValue && newV > rule.maxValue) ||
                (!hasNoMinValue && newV < rule.minValue))) {
            let errorText = lib_i18n_1.default.t('error-invalid-numeric-value-between', {
                min: rule.minValue,
                max: rule.maxValue,
            });
            if (hasNoMaxValue) {
                errorText = lib_i18n_1.default.t('error-invalid-numeric-value-above', {
                    min: rule.minValue,
                    max: rule.maxValue,
                });
            }
            else if (hasNoMinValue) {
                errorText = lib_i18n_1.default.t('error-invalid-numeric-value-below', {
                    min: rule.minValue,
                    max: rule.maxValue,
                });
            }
            setError(errorText);
            doSetHasError(true);
        }
        else if (rule.precisionValue && precisionValue > rule.precisionValue) {
            setError(lib_i18n_1.default.t('error-invalid-precision', { precision: rule.precisionValue }));
            doSetHasError(true);
        }
        else {
            setError('');
            doSetHasError(false);
        }
        doChangeAnswer({ value: newV });
        forceUpdate();
    }, [doChangeAnswer, doSetHasError, forceUpdate, rule]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(OpPerformQuestionCard_1.default, Object.assign({}, props, { disableChildren: viewMode }),
        react_1.default.createElement(Vertical_1.Vertical, null,
            error && react_1.default.createElement(Text_1.default, { color: 'error' }, error),
            react_1.default.createElement(Pane_1.default, { center: true, padding: true },
                react_1.default.createElement(TextField_1.default, { noMargin: viewMode, inputProps: { style: consts_1.performInputStyle }, className: myCss.textField, disabled: viewMode, type: "number", value: answer === null || answer === void 0 ? void 0 : answer.value, onChange: handleChange }))))), [answer, handleChange, myCss, props, viewMode, error]);
}
exports.OpPerformQuestionNumber = OpPerformQuestionNumber;
exports.default = OpPerformQuestionNumber;
